import EvaluationItemDto from "../../dto/EvaluationItemDto";

export default class EvaluationCategoryUpdateRequest {
  evaluationItems = [];
  constructor(datas) {
    datas.forEach(data => {
      const evaluationItemDto = new EvaluationItemDto(data);
      this.evaluationItems.push(evaluationItemDto);
    });
  }
}
